export default __webpack_public_path__ + "static/media/line_weight.8e592e6f.png";